import { render } from "./App.vue?vue&type=template&id=604fb748"
const script = {}

import "./App.vue?vue&type=style&index=0&id=604fb748&lang=css"
script.render = render

export default script